<template>
    <div class="content">
        <base-header class="pb-6">
            <b-row align-v="center" class="py-4">
                <b-col cols="7" lg="6">
                    <h6 class="h2 text-white d-inline-block mb-0">Utilities Data Manipulation Listing</h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </b-col>
                <b-col lg="6" cols="5" class="text-right">
                    <router-link :to="'/ProjectSiteUtilitiesDashboardDataNew/'+siteId">
                        <base-button size="sm" type="neutral"
                                     v-if="button_access.new_button == 'YES'">New Data Manipulation</base-button>
                    </router-link>
                </b-col>
            </b-row>
        </base-header>

        <b-container fluid class="mt--6">
            <div>
                <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
                    <template slot="header">
                        <b-row>
                            <h3 class="mb-0">Utilities Data Manipulation Listing</h3>
                            <b-col class="text-right">
                                <!-- responseTableCount: {{ tableData.length }} <br/> -->
                                <!-- button clicked: {{ tempButtonStatus }} <br/> -->
                                <!-- uniqueTable: {{ uniqueTable }} <br/> -->
                                <!-- uniqueUser: {{ uniqueUser }} <br/> -->
                                <!-- uniqueUserLength: {{ uniqueUser.length }} <br/> -->
                                <base-button size="sm" type="primary" @click="routerBack()"
                                >Back</base-button
                                >
                            </b-col>
                        </b-row>


                    </template>
                    <div>
                        <b-col cols="12" class="d-flex justify-content-center justify-content-sm-between flex-wrap">
                            <el-select
                                    class="select-primary pagination-select"
                                    v-model="pagination.perPage"
                                    placeholder="Per page">
                                <el-option
                                        class="select-primary"
                                        v-for="item in pagination.perPageOptions"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                </el-option>
                            </el-select>
                            <div>
                                <base-input v-model="searchQuery"
                                            prepend-icon="fas fa-search"
                                            placeholder="Search...">
                                </base-input>
                            </div>
                        </b-col>
                        <b-col cols="12">
                            <h3>Filters</h3>

                            <div class="form-row">
                                <b-col cols="6">
                                    <base-input
                                            label="Task Unique ID"
                                            name="Task Unique ID"
                                            v-model="filter.task_unique_id"
                                    >
                                    </base-input>
                                </b-col>
                            </div>

                            <b-row>
                                <b-col class="text-right">
                                    <!-- responseTableCount: {{ tableData.length }} <br/> -->
                                    <!-- button clicked: {{ tempButtonStatus }} <br/> -->
                                    <!-- uniqueTable: {{ uniqueTable }} <br/> -->
                                    <!-- uniqueUser: {{ uniqueUser }} <br/> -->
                                    <!-- uniqueUserLength: {{ uniqueUser.length }} <br/> -->
                                    <base-button size="sm" type="primary" @click="searchUtilitiesManipulationData()"
                                    >Search</base-button
                                    >
                                </b-col>
                            </b-row>

                        </b-col>
                        <b-col><br></b-col>
                        <el-table :data="queriedData"
                                  row-key="site_id"
                                  header-row-class-name="thead-light"
                                  @sort-change="sortChange">

                            <el-table-column label="Task Unique ID"
                                             min-width="140px"
                                             prop="task_unique_id"
                                             sortable>
                                <template v-slot="{row}">
                                    <b-media no-body class="align-items-center">
                                        <b-media-body>
                                            <span class="font-weight-600  mb-0 text-sm">{{row.task_unique_id}}</span>
                                        </b-media-body>
                                    </b-media>
                                </template>
                            </el-table-column>

                            <el-table-column min-width="110px" align="right" label="Actions">
                                <div slot-scope="{$index, row}" class="d-flex">
                                    <base-button
                                                 @click.native="handleDetails($index, row)" size="sm" type="primary">
                                        View / Edit
                                    </base-button>

                                    <base-button
                                                 @click.native="removeDetails($index, row)" size="sm" type="danger">
                                        Delete
                                    </base-button>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div
                            slot="footer"
                            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div class="">
                            <p class="card-category">
                                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

                                <span v-if="selectedRows.length">
                                  &nbsp; &nbsp; {{selectedRows.length}} rows selected
                                </span>
                            </p>
                        </div>
                        <base-pagination
                                class="pagination-no-border"
                                :current="pagination.currentPage"
                                :per-page="pagination.perPage"
                                :total="total"
                                @change="paginationChanged($event)">
                        </base-pagination>
                    </div>
                </card>
            </div>
        </b-container>

        <modal :show.sync="modals"
               size="lg"
               body-classes="p-0">
            <card type="secondary"
                  header-classes="bg-transparent pb-5"
                  body-classes="px-lg-5 py-lg-5"
                  class="border-0 mb-0">
                <template>
                    <div class="text-center text-muted mb-4">
                        <h3>Remove Action</h3>
                    </div>
                    <b-form role="form">
                        <div class="text-center">
                            <span>Do you want to delete this record?</span>
                        </div>
                        <div class="text-center">
                            <base-button class="my-4 remarks-button-css" type="danger" @click="deleteRecord()">Delete</base-button>
                            <base-button class="my-4 remarks-button-css" @click="clearModal()">Close</base-button>
                        </div>
                    </b-form>
                </template>
            </card>
        </modal>
    </div>
</template>
<script>
    import { Table, TableColumn, Select, Option } from 'element-ui';
    import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
    import { BasePagination } from '@/components';
    import standardPaginationMix from '@/assets/js/standardPaginationMix.js'
    import axios from 'axios'
    import Fuse from 'fuse.js';
    import {LoginURL, clientId, clientSecret, apiDomain, getHeader, parseDateToUTC} from '@/assets/js/config.js'
    import ErrorFunctionMixin from '@/assets/js/errorFunctionMix.js'

    export default {
        mixins: [standardPaginationMix, ErrorFunctionMixin],
        components: {
            BasePagination,
            RouteBreadCrumb,
            [Select.name]: Select,
            [Option.name]: Option,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn
        },
        created()
        {
            this.siteId = this.$route.params.id
            var developer_access = JSON.parse(window.localStorage.getItem('developer_access'))
            this.button_access.new_button = developer_access.access_create
            this.button_access.show_button = developer_access.access_show
            this.getUtilitiesManipulationData()
        },
        data() {
            return {
                propsToSearch:
                    [
                        'site_id',
                        'task_unique_id',
                    ],
                tableColumns: [],
                tableData: [],
                selectedRows: [],
                button_access:{
                    new_button: null,
                    show_button: null,
                },
                filter: {
                    from_date: null,
                    to_date: null,
                    mpuh_task_name: null
                },
                tempButtonStatus: false,
                uniqueTable: null,
                uniqueUser: null,
                siteId: null,
                modals: false,
                recordId : null,
                models: {
                    id : null
                },
            };
        },
        methods: {
            routerBack(){
                this.$router.push({path: '/ProjectSiteDashboardUtilities/' + this.$route.params.id})
            },
            fuseData() {
                this.fuseSearch = new Fuse(this.tableData, {
                    keys: this.propsToSearch,
                    threshold: 0.3
                });
            },
            paginationChanged(page) {
                this.pagination.currentPage = page
            },
            getUtilitiesManipulationData() {
                axios.get(apiDomain + 'project/get_utilities_manipulation_data_listing/'+this.$route.params.id, { headers: getHeader() })
                    .then ( response => {
                        if (response.status === 200)
                        {
                            this.tableData = response.data.data;
                            this.fuseData();
                        }
                    })
                    .catch ( error => {
                        this.errorFunction(error, "Utilities Data Manipulation Listing")
                    });
            },
            searchUtilitiesManipulationData() {
                this.tempButtonStatus = true;
                axios.post(apiDomain + 'project/search_utilities_manipulation_data_listing/'+this.$route.params.id, this.filter, {
                    headers: getHeader(),
                })
                    .then ( response => {
                        if (response.status === 200)
                        {
                            this.tableData = response.data.data;
                            this.fuseData();
                        }
                    })
                    .catch ( error => {
                        this.errorFunction(error, "Search Utilities Data Manipulation Listing")
                    });
            },
            handleDetails(index, row)
            {
                this.$router.push({path: '/ProjectSiteUtilitiesDashboardDataEdit/' + row.id })
            },
            removeDetails(index,row){

                this.recordId = row.id;
                this.modals = true;
            },
            deleteRecord(){
                axios.post(apiDomain + 'project/delete_utilities_data_manipulation/'+this.recordId, this.models, { headers: getHeader() })
                    .then ( response => {
                        this.$notify({
                            message: '<b>Delete Data Manipulation : ' + this.recordId + '</b> - Successfully Deleted.',
                            timeout: 10000,
                            icon: 'ni ni-bell-55',
                            type: 'default',
                        });
                        this.clearModal();
                        this.getUtilitiesManipulationData();

                    })
                    .catch ( error => {
                        this.errorFunction(error, "Delete New Data Manipulation")
                    });
            },
            clearModal(){
                this.modals= false
            },
        }
    };
</script>
<style>
    .no-border-card .card-footer{
        border-top: 0;
    }
</style>
